// src/components/chat-list.ts
import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { ChatItem } from './chat-container'

@customElement('chat-list')
export class ChatList extends LitElement {
    @property({ type: Array }) chats: ChatItem[] = []
    @property({ type: String }) selectedChatId = ''

    static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        .list-container {
            flex: 1;
            overflow-y: auto;
            overscroll-behavior: contain;
        }

        .list-container:first-child {
            border-top: 1px solid var(--border-color);
        }

        .chat-item {
            padding: var(--s1);
            cursor: pointer;
            border-bottom: 1px solid var(--border-color);
            transition:
                background-color var(--transition-fast),
                box-shadow var(--transition-fast);
        }

        .chat-item:hover {
            background-color: var(--color-bg-tertiary);
            box-shadow: inset 4px 0 0 0 var(--border-color);
        }

        .chat-item.selected {
            background-color: var(--bg-secondary);
            box-shadow: inset 4px 0 0 0 var(--color-accent);
        }

        .chat-name {
            font-weight: bold;
            font-size: var(--s1);
        }

        .chat-message {
            color: var(--text-primary);
            font-size: var(--s1);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: var(--base-font-family);
        }
    `

    private _selectChat(id: string) {
        this.dispatchEvent(
            new CustomEvent('chat-selected', {
                detail: { id },
                bubbles: true,
                composed: true,
            }),
        )
    }

    private _createNewChat() {
        this.dispatchEvent(
            new CustomEvent('new-chat-requested', {
                bubbles: true,
                composed: true,
            }),
        )
    }

    render() {
        return html`
            <!--
            <e-box>
                <e-button @click=${this._createNewChat} accent="blue" fullWidth>New</e-button>
            </e-box>
            -->
            <e-box>
                <e-text textType="heading">Chat List</e-text>
            </e-box>
            <div class="list-container">
                ${this.chats.map(
                    chat => html`
                        <e-stack
                            space="var(--s-1)"
                            @click=${() => this._selectChat(chat.id)}
                            class="chat-item ${chat.id === this.selectedChatId ? 'selected' : ''}"
                        >
                            <e-cluster nowrap justify="space-between">
                                <e-text class="chat-name">${chat.name}</e-text>
                                <e-text class="chat-date"></e-text>
                            </e-cluster>
                            <div class="chat-message">${chat.lastMessage || ''}</div>
                        </e-stack>
                    `,
                )}
            </div>

            <div class="reset-container">
                <e-box>
                    <e-cluster justify="space-between">
                        <e-text>v${APP_VERSION}</e-text>
                        <e-text>${COMMIT_HASH}</e-text>
                    </e-cluster>
                </e-box>
            </div>
        `
    }
}
